import { cn } from "@/lib/utils";

/** His face: the thread from the ask, to his card, to the ring (the mock's chapter 1). */
export const BASH_FACE_SRC = "/developers/family/face-bash.webp";

export function BashFace({
  className,
  alt = "",
}: {
  /** The size, e.g. `size-16`. */
  className: string;
  alt?: string;
}) {
  return (
    // eslint-disable-next-line @next/next/no-img-element -- a 4 KB static face, nothing to optimise
    <img
      src={BASH_FACE_SRC}
      alt={alt}
      className={cn("shrink-0 rounded-full object-cover", className)}
    />
  );
}
